import { render } from "./back-button.vue?vue&type=template&id=38e900cd&scoped=true"
const script = {}

import "./back-button.vue?vue&type=style&index=0&id=38e900cd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38e900cd"]])

export default __exports__